<ng-container *ngIf="bookingStore.loaded$ | async; else loader">
  <ng-container
    *ngIf="(bookingStore.selectedPlan$ | async) === BookingPlans.Pro; else trialConfirmation"
  >
    <div class="checkout-wrapper">
      <div class="back-btn-wrapper">
        <button
          *ngIf="bookingStore.loaded$ | async"
          mat-raised-button
          gtm="onSelect"
          gtmAction="Booking Stepper"
          gtmCategory="booking"
          color="primary"
          (click)="onBack()"
          data-at-back-button
        >
          {{ 'GENERAL.BUTTON.BACK' | translate }}
        </button>
      </div>
      <div class="checkout-content">
        <div class="checkout-list-wrapper">
          <div class="checkout-list">
            <div class="checkout-header-wrapper">
              <h3 class="checkout-list-header">
                {{ '+FLAT_BOOKING.CHECKOUT.PRO_LIST_DESCRIPTION' | translate }}
              </h3>
            </div>
            <div class="checkout-list-entry" data-at-installation>
              <p>{{ '+FLAT_BOOKING.CHECKOUT.PRO_PACKAGE_DESCRIPTION' | translate }}</p>
            </div>
          </div>
        </div>
        <div class="checkout-summary-wrapper">
          <app-flat-booking-summary data-at-checkout-section (continue)="onContinue()">
          </app-flat-booking-summary>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #trialConfirmation>
  <ng-container *ngIf="bookingStore.loaded$ | async; else loader">
    <div
      class="trial-confirmation-container flex flex-col gap-[32px] justify-center items-center"
      *ngIf="bookingStore.error$ | async as error; else trialSubscriptionSuccess"
    >
      <mat-icon class="main-icon red-icon">cancel</mat-icon>
      <h2>
        {{ '+BOOKING.CHECKOUT.ERROR.TITLE' | translate }}
      </h2>
      <p>
        {{
          '+BOOKING.CHECKOUT.ERROR.' + (error.extendedPayload?.errorType || error.errorType)
            | translate
        }}
      </p>
      <button
        gtm="onGoToPage"
        gtmAction="Booking 1st step"
        gtmCategory="booking"
        mat-raised-button
        color="primary"
        (click)="onReset()"
        class="go-to-installation-btn"
      >
        <mat-icon>arrow_back</mat-icon>
        <span>{{ '+BOOKING.CHECKOUT.TRIAL_CONFIRMATION.ERROR_BTN' | translate }}</span>
      </button>
    </div>
  </ng-container>
</ng-template>

<ng-template #trialSubscriptionSuccess>
  <div
    data-at-trial-confirmation
    class="trial-confirmation-container flex flex-col gap-[32px] justify-center items-center"
  >
    <mat-icon class="main-icon">check_circle</mat-icon>
    <h2 data-at-thanks-for-trial>
      {{ '+BOOKING.CHECKOUT.TRIAL_CONFIRMATION.TITLE' | translate }}
    </h2>
    <p>{{ '+BOOKING.CHECKOUT.TRIAL_CONFIRMATION.DESCRIPTION' | translate }}</p>
    <a
      [routerLink]="['/installations', (bookingStore.selectedDevices$ | async)[0]?.installationId]"
    >
      <button
        data-at-go-to-devices-button
        gtm="onGoToPage"
        gtmAction="Installation details"
        gtmCategory="booking"
        mat-raised-button
        color="primary"
        class="go-to-installation-btn"
      >
        <span>{{ '+BOOKING.CHECKOUT.TRIAL_CONFIRMATION.BTN' | translate }}</span>
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </a>
  </div>
</ng-template>

<ng-template #loader>
  <vi-loader data-at-loader-booking [isLoading]="true"></vi-loader>
</ng-template>
